import type { IPartnerSettings } from '@/appSettings/Partners'
import { usePartner } from '@/context/PartnerContext'
import {
  Box,
  Center,
  Image,
  Portal,
  Spinner,
  Stack,
  Text,
} from '@chakra-ui/react'
import { motion } from 'framer-motion'


const supportedPartners: IPartnerSettings['partner'][] = ['Jap']

export const AppLoading = () => {
  const {
    currentPartner,
    getBaseUrl
  } = usePartner()

  let logo =
    currentPartner?.partner &&
    supportedPartners.includes(currentPartner?.partner) &&
    `${getBaseUrl()}/branding/${currentPartner.partner.toLowerCase()}/favicons/apple-icon.png`

  if (!logo) logo = undefined

  return (
    <Portal>
      <Center position='fixed' top={0} left={0} right={0} bottom={0} w="100vw" h="100vh" background={logo ? 'white' : 'neutral.50'}>
        <LogoLoading logo={logo} />
      </Center>
    </Portal>
  )
}

const LogoLoading = ({ logo }: { logo?: string }) => {
  return (
    <motion.div
      animate={{ '--opacity': 1 } as any}
      initial={{ '--opacity': 0 } as any}
      transition={{
        delay: 0.1,
        duration: 0.6,
        loop: Infinity,
      }}
    >
      <Stack
        alignItems="center"
        textAlign="center"
        gap={8}
        opacity={'var(--opacity)'}
      >
        {logo ? (
          <Box position="relative">
            <Image src={logo} h={'clamp(10vh, 5vw, 60px)'} />
            <motion.div
              animate={{ '--position': '100%' } as any}
              initial={{ '--position': '0%' } as any}
              transition={{
                delay: 0.7,
                duration: 0.5,
                loop: Infinity,
                ease: 'linear',
                repeat: Infinity,
                repeatDelay: 1.5,
              }}
            >
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                background={
                  'radial-gradient(circle, rgba(0,0,0,0) 0%, rgba(0,0,0,0) calc(var(--position) - 2%), rgba(255,255,255) calc(var(--position) - 2%), rgba(255,255,255) calc(var(--position) + 2%), rgba(0,0,0,0) calc(var(--position) + 2%), rgba(0,0,0,0) 100%);'
                }
              />
            </motion.div>
          </Box>
        ) : (
          <Spinner
            size="xl"
            emptyColor="neutral.200"
            color="primary.800"
            speed="0.7s"
          />
        )}
        <Text fontSize="2xl" ml={3} color={'primary.800'}>
          Načítání . . .
        </Text>
      </Stack>
    </motion.div>
  )
}
